<!-- Start Breadcrumbs -->
<app-breadcrumbs title="DASHBOARD" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>
<!-- End Breadcrumbs -->

<div class="row">
    <div class="col">
        <div class="h-100">


            <!-- HERO OPERATOR SECTION -->
            <div class="operator-hero-card mb-4">
                <div class="hero-deco hero-deco-1"></div>
                <div class="hero-deco hero-deco-2"></div>
                <div class="hero-deco hero-deco-3"></div>

                <div class="row align-items-center g-0">
                    <!-- LEFT: Información del operador -->
                    <div class="col-lg-7 col-md-7">
                        <div class="hero-content-left">
                            <div class="hero-welcome-pill mb-3">
                                <i class="ri-radar-line me-1"></i>
                                 Trazabilidad en Tiempo Real
                            </div>
                            <h1 class="hero-operator-name">{{user?.operador?.name}}</h1>
                            <div class="d-flex align-items-center flex-wrap gap-2 mb-3">
                                <span class="hero-ruc-badge">
                                    <i class="ri-government-line me-1"></i>RUC {{user?.operador?.ruc}}
                                </span>
                                <span class="hero-year-badge">
                                    <i class="ri-calendar-2-line me-1"></i>Período {{filtros.anio}}
                                </span>
                            </div>

                            <div class="hero-greeting-block">
                                <div class="hero-greeting-icon">
                                    <i class="ri-hand-heart-line"></i>
                                </div>
                                <div>
                                    <p class="hero-greeting-welcome mb-1">
                                        ¡Hola de nuevo, <strong>{{user?.userName | uppercase}}</strong>! 👋
                                    </p>
                                    <p class="hero-greeting-sub">
                                         Hemos preparado tu resumen ejecutivo de trazabilidad.
                                    </p>
                                     <p class="hero-greeting-sub mb-0">
                                        Consulta el estado, seguimiento y consolidado de tus operaciones de
                                          comercio exterior realizadas con <strong>DACHA</strong>.
                                    </p>
                                </div>
                            </div>

                            <div class="hero-chips mt-3">
                                <span class="hero-chip" >
                                    <i class="ri-ship-2-line me-1"></i>Marítimo
                                </span>
                                <span class="hero-chip" >
                                    <i class="ri-flight-takeoff-line me-1"></i>Aéreo
                                </span>
                                <span class="hero-chip" >
                                    <i class="ri-truck-line me-1"></i>Terrestre
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- RIGHT: Logo impactante -->
                    <div class="col-lg-5 col-md-5">
                        <div class="hero-logo-section">
                            <div class="hero-logo-ring hero-logo-ring-outer"></div>
                            <div class="hero-logo-ring hero-logo-ring-inner"></div>
                            <div class="hero-logo-card">
                                <img *ngIf="user?.operador?.logo && !logoLoadError"
                                     src="{{CDN_BASE + user?.operador?.logo}}"
                                     ngbTooltip="{{user?.operador?.name}}"
                                     (error)="onLogoError()"
                                     class="hero-logo-img"/>
                                <div class="hero-logo-fallback" *ngIf="!user?.operador?.logo || logoLoadError"
                                     ngbTooltip="{{user?.operador?.name}}">
                                    <i class="ri-building-2-fill hero-logo-fallback-icon"></i>
                                    <span class="hero-logo-fallback-initials">{{ getOperadorInitials(user?.operador?.name) }}</span>
                                </div>
                                <div class="hero-logo-brand-name">{{user?.operador?.name}}</div>
                            </div>
                            <div class="hero-logo-verified mt-2">
                                <i class="ri-shield-check-fill me-1"></i>Operador Verificado
                            </div>
                        </div>
                    </div>
                </div>
            </div>

             <!-- FILTER BAR -->
             <div class="dashboard-filters card mb-3">
                  <div class="card-body py-2 px-3">
                       <div class="row align-items-center g-2">
                            <div class="col-auto">
                                 <span class="text-muted small fw-medium"><i class="ri-filter-3-line me-1"></i>Filtros</span>
                            </div>
                            <div class="col-md-3 col-sm-6">
                                 <select class="form-select form-select-sm" data-choices data-choices-search-false [(ngModel)]="filtros.localid" (change)="filtrarInformacionDashboard()">
                                      <option value="{{local.local_id}}" *ngFor="let local of localList">{{local.local_descripcion}}</option>
                                 </select>
                            </div>
                            <div class="col-md-2 col-sm-6">
                                 <select class="form-select form-select-sm" data-choices data-choices-search-false [(ngModel)]="filtros.mes" (change)="filtrarInformacionDashboard()">
                                      <option value="{{mes.value}}" *ngFor="let mes of mesesList">{{mes.label}}</option>
                                 </select>
                            </div>
                            <div class="col-md-2 col-sm-6">
                                 <div class="input-step full-width step-primary input-step-sm">
                                      <button type="button" class="minus" (click)="decrementYear()">&#8211;</button>
                                      <input type="number" class="product-quantity" [(ngModel)]="filtros.anio" min="2020" (change)="filtrarInformacionDashboard()" max="2030" readonly>
                                      <button type="button" class="plus" (click)="incremetYear()">+</button>
                                 </div>
                            </div>
                            <div class="col-auto ms-auto">
                                 <button class="btn btn-primary btn-sm d-flex align-items-center gap-1"
                                         (click)="filtrarInformacionDashboard()"
                                         [disabled]="isLoadingChartOperaciones || isLoadingChartTopCliente">
                                      <i class="ri-refresh-line"
                                         [class.spin]="isLoadingChartOperaciones || isLoadingChartTopCliente"></i>
                                      <span>Actualizar</span>
                                 </button>
                            </div>
                       </div>
                  </div>
             </div>


             <!-- KPI CARDS -->
            <div class="kpi-grid mb-4" *ngIf="enabledCountTO">

                <div class="kpi-col">
                    <div class="kpi-card kpi-primary card-animate">
                        <div class="kpi-card-body">
                            <div class="kpi-icon-wrap">
                                <i-feather name="anchor" class="kpi-icon"></i-feather>
                            </div>
                            <div class="kpi-content">
                                <p class="kpi-label">Total Cont. Marítimos</p>
                                <h3 class="kpi-value">
                                    <span *ngIf="dataTotalesDashboard?.total_contenedores_maritimos > 0; else cero"
                                          [CountTo]="dataTotalesDashboard?.total_contenedores_maritimos" [from]="0"
                                          [duration]="getCountDuration(dataTotalesDashboard?.total_contenedores_maritimos)"></span>
                                    <small class="kpi-unit"> CNT</small>
                                </h3>
                                <div class="kpi-progress">
                                    <div class="kpi-progress-bar" [style.width.%]="dataTotalesDashboard?.total_contenedores_maritimos > 0 ? 100 : 0"></div>
                                </div>
                                <span class="kpi-badge"><i class="ri-ship-2-line me-1"></i>Marítimo</span>
                            </div>
                        </div>
                    </div>
                </div>

                 <div class="kpi-col">
                      <div class="kpi-card kpi-purple card-animate">
                           <div class="kpi-card-body">
                                <div class="kpi-icon-wrap">
                                     <i-feather name="file-text" class="kpi-icon"></i-feather>
                                </div>
                                <div class="kpi-content">
                                     <p class="kpi-label">Total BK</p>
                                     <h3 class="kpi-value">
                                    <span *ngIf="dataTotalesDashboard?.total_bk > 0; else cero"
                                          [CountTo]="dataTotalesDashboard?.total_bk" [from]="0"
                                          [duration]="getCountDuration(dataTotalesDashboard?.total_bk)"></span>
                                     </h3>
                                     <div class="kpi-progress">
                                          <div class="kpi-progress-bar" [style.width.%]="dataTotalesDashboard?.total_bk > 0 ? 100 : 0"></div>
                                     </div>
                                     <span class="kpi-badge"><i class="ri-file-list-3-line me-1"></i>Bookings</span>
                                </div>
                           </div>
                      </div>
                 </div>

                <div class="kpi-col">
                    <div class="kpi-card kpi-teal card-animate">
                        <div class="kpi-card-body">
                            <div class="kpi-icon-wrap">
                                <i-feather name="users" class="kpi-icon"></i-feather>
                            </div>
                            <div class="kpi-content">
                                <p class="kpi-label">N&deg; Clientes</p>
                                <h3 class="kpi-value">
                                    <span *ngIf="dataTotalesDashboard?.total_clientes > 0; else cero"
                                          [CountTo]="dataTotalesDashboard?.total_clientes" [from]="0"
                                          [duration]="getCountDuration(dataTotalesDashboard?.total_clientes)"></span>
                                </h3>
                                <div class="kpi-progress">
                                    <div class="kpi-progress-bar" [style.width.%]="dataTotalesDashboard?.total_clientes > 0 ? 100 : 0"></div>
                                </div>
                                <span class="kpi-badge"><i class="ri-global-line me-1"></i>General</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="kpi-col">
                    <div class="kpi-card kpi-amber card-animate">
                        <div class="kpi-card-body">
                            <div class="kpi-icon-wrap">
                                <i-feather name="wind" class="kpi-icon"></i-feather>
                            </div>
                            <div class="kpi-content">
                                <p class="kpi-label">Op. Aéreas</p>
                                <h3 class="kpi-value">
                                    <span *ngIf="dataTotalesDashboard?.total_aereas > 0; else cero"
                                          [CountTo]="dataTotalesDashboard?.total_aereas" [from]="0"
                                          [duration]="getCountDuration(dataTotalesDashboard?.total_aereas)"></span>
                                </h3>
                                <div class="kpi-progress">
                                    <div class="kpi-progress-bar" [style.width.%]="dataTotalesDashboard?.total_aereas > 0 ? 100 : 0"></div>
                                </div>
                                <span class="kpi-badge"><i class="ri-flight-takeoff-line me-1"></i>Aéreo</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="kpi-col">
                    <div class="kpi-card kpi-green card-animate">
                        <div class="kpi-card-body">
                            <div class="kpi-icon-wrap">
                                <i-feather name="truck" class="kpi-icon"></i-feather>
                            </div>
                            <div class="kpi-content">
                                <p class="kpi-label">Op. Terrestres</p>
                                <h3 class="kpi-value">
                                    <span *ngIf="dataTotalesDashboard?.total_terrestres > 0; else cero"
                                          [CountTo]="dataTotalesDashboard?.total_terrestres" [from]="0"
                                          [duration]="getCountDuration(dataTotalesDashboard?.total_terrestres)"></span>
                                </h3>
                                <div class="kpi-progress">
                                    <div class="kpi-progress-bar" [style.width.%]="dataTotalesDashboard?.total_terrestres > 0 ? 100 : 0"></div>
                                </div>
                                <span class="kpi-badge"><i class="ri-truck-line me-1"></i>Terrestre</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="kpi-col">
                    <div class="kpi-card kpi-red card-animate">
                        <div class="kpi-card-body">
                            <div class="kpi-icon-wrap">
                                <i-feather name="package" class="kpi-icon"></i-feather>
                            </div>
                            <div class="kpi-content">
                                <p class="kpi-label">Op. Carga Suelta</p>
                                <h3 class="kpi-value">
                                    <span *ngIf="dataTotalesDashboard?.total_carga_suelta > 0; else cero"
                                          [CountTo]="dataTotalesDashboard?.total_carga_suelta" [from]="0"
                                          [duration]="getCountDuration(dataTotalesDashboard?.total_carga_suelta)"></span>
                                </h3>
                                <div class="kpi-progress">
                                    <div class="kpi-progress-bar" [style.width.%]="dataTotalesDashboard?.total_carga_suelta > 0 ? 100 : 0"></div>
                                </div>
                                <span class="kpi-badge"><i class="ri-archive-line me-1"></i>Carga Suelta</span>
                            </div>
                        </div>
                    </div>
                </div>



            </div>

            <!-- CHARTS ROW -->
            <div class="row g-3 mb-4 charts-row">

                <div class="col-xl-6">
                    <div class="card chart-card">
                        <div class="card-header align-items-center d-flex">
                            <div class="flex-grow-1">
                                <h5 class="card-title mb-0">
                                    <i class="ri-line-chart-line text-primary me-2"></i>
                                    Operaciones del año <strong>{{filtros.anio}}</strong>
                                </h5>
                                <p class="text-muted small mt-1 mb-0">
                                    Evolucion de N° Contenedores por periodo &nbsp;
                                    <span class="badge bg-soft-primary text-primary" *ngIf="filtros.mes != -1 && filtros.mes != '-1'">
                                        <i class="ri-calendar-check-line me-1"></i>Vista por Semana
                                    </span>
                                    <span class="badge bg-soft-secondary text-secondary" *ngIf="filtros.mes == -1 || filtros.mes == '-1'">
                                        <i class="ri-calendar-2-line me-1"></i>Vista por Mes
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div class="card-body chart-body">
                            <div class="chart-overlay" *ngIf="isLoadingChartOperaciones">
                                <div class="chart-state-content">
                                    <div class="spinner-border text-primary spinner-border-sm" role="status"></div>
                                    <span class="ms-2 text-muted small">Cargando...</span>
                                </div>
                            </div>
                            <div class="chart-overlay" *ngIf="emptyChartOperaciones && !isLoadingChartOperaciones">
                                <div class="chart-state-content flex-column">
                                    <i-feather name="bar-chart-2" class="chart-empty-icon"></i-feather>
                                    <p class="mt-2 mb-0 text-muted text-center small">No existe suficiente informacion para procesar este grafico.</p>
                                </div>
                            </div>
                            <apx-chart *ngIf="distributedColumnChart && !isLoadingChartOperaciones && !emptyChartOperaciones"
                                       [series]="distributedColumnChart?.series"
                                       [chart]="distributedColumnChart?.chart"
                                       [colors]="distributedColumnChart?.colors"
                                       [stroke]="distributedColumnChart?.stroke"
                                       [fill]="distributedColumnChart?.fill"
                                       [dataLabels]="distributedColumnChart?.dataLabels"
                                       [markers]="distributedColumnChart?.markers"
                                       [xaxis]="distributedColumnChart?.xaxis"
                                       [yaxis]="distributedColumnChart?.yaxis"
                                       [grid]="distributedColumnChart?.grid"
                                       [legend]="distributedColumnChart?.legend"
                                       [tooltip]="distributedColumnChart?.tooltip">
                            </apx-chart>
                        </div>
                    </div>
                </div>

                <div class="col-xl-6">
                    <div class="card chart-card">
                        <div class="card-header align-items-center d-flex">
                            <div class="flex-grow-1">
                                <h5 class="card-title mb-0">
                                    <i class="ri-bar-chart-horizontal-line text-success me-2"></i>
                                    Top Exportadores
                                </h5>
                                <p class="text-muted small mt-1 mb-0">N° Contenedores por cliente
                                     <span class="badge bg-soft-primary text-primary" *ngIf="filtros.mes != -1 && filtros.mes != '-1'">
                                        <i class="ri-calendar-check-line me-1"></i>Vista por Semana
                                    </span>
                                     <span class="badge bg-soft-secondary text-secondary" *ngIf="filtros.mes == -1 || filtros.mes == '-1'">
                                        <i class="ri-calendar-2-line me-1"></i>Vista por Mes
                                    </span>
                                </p>
                            </div>
                        </div>
                        <!-- OTROS: Leyenda siempre visible encima del gráfico -->
                        <div class="otros-legend-bar"
                             *ngIf="graficoTopClienteData?.labels?.includes('OTROS') && !isLoadingChartTopCliente && !emptyChartTopCliente">
                            <span class="otros-legend-dot"></span>
                            <span class="otros-legend-text">
                                El grupo <strong>OTROS</strong> agrupa clientes de menor volumen
                            </span>
                            <button class="btn btn-sm btn-outline-primary otros-legend-btn"
                                    (click)="openModalOtrosExportadores()">
                                <i class="ri-eye-line me-1"></i>Ver detalle
                            </button>
                        </div>
                        <div class="card-body chart-body">
                            <div class="chart-overlay" *ngIf="isLoadingChartTopCliente">
                                <div class="chart-state-content">
                                    <div class="spinner-border text-success spinner-border-sm" role="status"></div>
                                    <span class="ms-2 text-muted small">Cargando...</span>
                                </div>
                            </div>
                            <div class="chart-overlay" *ngIf="emptyChartTopCliente && !isLoadingChartTopCliente">
                                <div class="chart-state-content flex-column">
                                    <i-feather name="users" class="chart-empty-icon"></i-feather>
                                    <p class="mt-2 mb-0 text-muted text-center small">No existe suficiente informacion para procesar este grafico.</p>
                                </div>
                            </div>
                            <apx-chart *ngIf="updatingDonutChart && !isLoadingChartTopCliente && !emptyChartTopCliente"
                                       [series]="updatingDonutChart?.series"
                                       [chart]="updatingDonutChart?.chart"
                                       [plotOptions]="updatingDonutChart?.plotOptions"
                                       [dataLabels]="updatingDonutChart?.dataLabels"
                                       [xaxis]="updatingDonutChart?.xaxis"
                                       [yaxis]="updatingDonutChart?.yaxis"
                                       [colors]="updatingDonutChart?.colors"
                                       [grid]="updatingDonutChart?.grid"
                                       [tooltip]="updatingDonutChart?.tooltip"
                                       [legend]="updatingDonutChart?.legend">
                            </apx-chart>
                        </div>
                    </div>
                </div>

            </div>

            <!-- SECOND CHARTS ROW: MOV por Tipo Contenedor + Tipo Embarque -->
            <div class="row g-3 mb-4 charts-row">

                <div class="col-xl-6">
                    <div class="card chart-card">
                        <div class="card-header align-items-center d-flex">
                            <div class="flex-grow-1">
                                <h5 class="card-title mb-0">
                                    <i class="ri-stack-line text-warning me-2"></i>
                                    Mov. por Tipo de Contenedor
                                </h5>
                                <p class="text-muted small mt-1 mb-0">N° Contenedores por tipo de contenedor
                                     <span class="badge bg-soft-primary text-primary" *ngIf="filtros.mes != -1 && filtros.mes != '-1'">
                                        <i class="ri-calendar-check-line me-1"></i>Vista por Semana
                                    </span>
                                     <span class="badge bg-soft-secondary text-secondary" *ngIf="filtros.mes == -1 || filtros.mes == '-1'">
                                        <i class="ri-calendar-2-line me-1"></i>Vista por Mes
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div class="card-body chart-body">
                            <div class="chart-overlay" *ngIf="isLoadingChartTipoContenedor">
                                <div class="chart-state-content">
                                    <div class="spinner-border text-warning spinner-border-sm" role="status"></div>
                                    <span class="ms-2 text-muted small">Cargando...</span>
                                </div>
                            </div>
                            <div class="chart-overlay" *ngIf="emptyChartTipoContenedor && !isLoadingChartTipoContenedor">
                                <div class="chart-state-content flex-column">
                                    <i-feather name="bar-chart-2" class="chart-empty-icon"></i-feather>
                                    <p class="mt-2 mb-0 text-muted text-center small">No existe suficiente información para este gráfico.</p>
                                </div>
                            </div>
                            <apx-chart *ngIf="graficoTipoContenedor && !isLoadingChartTipoContenedor && !emptyChartTipoContenedor"
                                       [series]="graficoTipoContenedor?.series"
                                       [chart]="graficoTipoContenedor?.chart"
                                       [colors]="graficoTipoContenedor?.colors"
                                       [plotOptions]="graficoTipoContenedor?.plotOptions"
                                       [dataLabels]="graficoTipoContenedor?.dataLabels"
                                       [fill]="graficoTipoContenedor?.fill"
                                       [xaxis]="graficoTipoContenedor?.xaxis"
                                       [yaxis]="graficoTipoContenedor?.yaxis"
                                       [legend]="graficoTipoContenedor?.legend"
                                       [grid]="graficoTipoContenedor?.grid"
                                       [tooltip]="graficoTipoContenedor?.tooltip">
                            </apx-chart>
                        </div>
                    </div>
                </div>

                <div class="col-xl-6">
                    <div class="card chart-card">
                        <div class="card-header align-items-center d-flex">
                            <div class="flex-grow-1">
                                <h5 class="card-title mb-0">
                                    <i class="ri-ship-line text-primary me-2"></i>
                                    Mov. por Tipo de Embarque
                                </h5>
                                <p class="text-muted small mt-1 mb-0">N° Contenedores por tipo de embarque ({{ tipoEmbarquesNames }})
                                     <span class="badge bg-soft-primary text-primary" *ngIf="filtros.mes != -1 && filtros.mes != '-1'">
                                        <i class="ri-calendar-check-line me-1"></i>Vista por Semana
                                    </span>
                                     <span class="badge bg-soft-secondary text-secondary" *ngIf="filtros.mes == -1 || filtros.mes == '-1'">
                                        <i class="ri-calendar-2-line me-1"></i>Vista por Mes
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div class="card-body chart-body">
                            <div class="chart-overlay" *ngIf="isLoadingChartTipoEmbarque">
                                <div class="chart-state-content">
                                    <div class="spinner-border text-primary spinner-border-sm" role="status"></div>
                                    <span class="ms-2 text-muted small">Cargando...</span>
                                </div>
                            </div>
                            <div class="chart-overlay" *ngIf="emptyChartTipoEmbarque && !isLoadingChartTipoEmbarque">
                                <div class="chart-state-content flex-column">
                                    <i-feather name="ship" class="chart-empty-icon"></i-feather>
                                    <p class="mt-2 mb-0 text-muted text-center small">No existe suficiente información para este gráfico.</p>
                                </div>
                            </div>
                            <apx-chart *ngIf="graficoTipoEmbarque && !isLoadingChartTipoEmbarque && !emptyChartTipoEmbarque"
                                       [series]="graficoTipoEmbarque?.series"
                                       [chart]="graficoTipoEmbarque?.chart"
                                       [colors]="graficoTipoEmbarque?.colors"
                                       [stroke]="graficoTipoEmbarque?.stroke"
                                       [fill]="graficoTipoEmbarque?.fill"
                                       [dataLabels]="graficoTipoEmbarque?.dataLabels"
                                       [markers]="graficoTipoEmbarque?.markers"
                                       [xaxis]="graficoTipoEmbarque?.xaxis"
                                       [yaxis]="graficoTipoEmbarque?.yaxis"
                                       [legend]="graficoTipoEmbarque?.legend"
                                       [grid]="graficoTipoEmbarque?.grid"
                                       [tooltip]="graficoTipoEmbarque?.tooltip">
                            </apx-chart>
                        </div>
                    </div>
                </div>

            </div>

            <!-- ACCESOS DIRECTOS -->
            <div class="row g-3 mb-3">
                <div class="col-12">
                    <h6 class="section-title">
                        <i class="ri-apps-2-line me-2"></i>Accesos Rapidos
                    </h6>
                </div>

                <div class="col-xl-3 col-lg-4 col-md-6">
                    <div class="shortcut-card card-animate" (click)="abrilModalClasificacionClientes(modalClasificacionCliente)">
                        <div class="shortcut-icon-wrap shortcut-icon-blue">
                            <i class="ri-building-2-line shortcut-icon"></i>
                        </div>
                        <div class="shortcut-content">
                            <h6 class="shortcut-title">Clasificación de Clientes</h6>
                            <p class="shortcut-desc">Ver ranking y KPI por cliente</p>
                        </div>
                        <div class="shortcut-arrow">
                            <i-feather name="arrow-right" class="shortcut-arrow-icon"></i-feather>
                        </div>
                    </div>
                </div>

                <div class="col-xl-3 col-lg-4 col-md-6">
                    <div class="shortcut-card card-animate" [routerLink]="'/control/documentacion'">
                        <div class="shortcut-icon-wrap shortcut-icon-teal">
                            <lord-icon src="https://cdn.lordicon.com/iyqamhwd.json" trigger="hover"
                                       colors="primary:#00b8a9,secondary:#17a2b8" style="width:52px;height:52px">
                            </lord-icon>
                        </div>
                        <div class="shortcut-content">
                            <h6 class="shortcut-title">DAM Regularizadas</h6>
                            <p class="shortcut-desc">Control de documentacion DAM</p>
                        </div>
                        <div class="shortcut-arrow">
                            <i-feather name="arrow-right" class="shortcut-arrow-icon"></i-feather>
                        </div>
                    </div>
                </div>

                <div class="col-xl-3 col-lg-4 col-md-6" *ngIf="user.type == TYPE_USER.ADMINISTRADOR">
                    <div class="shortcut-card card-animate" (click)="descargarEECC()">
                        <div class="shortcut-icon-wrap shortcut-icon-orange">
                            <lord-icon src="https://cdn.lordicon.com/yeallgsa.json" trigger="hover"
                                       colors="primary:#f39c12,secondary:#fd7e62" style="width:52px;height:52px">
                            </lord-icon>
                        </div>
                        <div class="shortcut-content">
                            <h6 class="shortcut-title">Estado de Cuenta</h6>
                            <p class="shortcut-desc">Descargar E.E.C.C. actual</p>
                        </div>
                        <div class="shortcut-arrow">
                            <i-feather name="arrow-right" class="shortcut-arrow-icon"></i-feather>
                        </div>
                    </div>
                </div>

                <div class="col-xl-3 col-lg-4 col-md-6">
                    <div class="shortcut-card card-animate" [routerLink]="'/grafico/dam'">
                        <div class="shortcut-icon-wrap shortcut-icon-purple">
                            <i class="ri-bar-chart-grouped-line shortcut-icon"></i>
                        </div>
                        <div class="shortcut-content">
                            <h6 class="shortcut-title">Gráfico KPI</h6>
                            <p class="shortcut-desc">Indicadores de rendimiento DAM</p>
                        </div>
                        <div class="shortcut-arrow">
                            <i-feather name="arrow-right" class="shortcut-arrow-icon"></i-feather>
                        </div>
                    </div>
                </div>


            </div>

        </div>
    </div>
</div>

<!-- MODAL: TERMINOS Y CONDICIONES -->
<ng-template #modalTerminosCondiciones role="document" let-modal>
    <div class="modal-header">
        <h5 class="modal-title mt-0 text-primary">BIENVENIDOS A ITURRIAPP - OPERADOR</h5>
    </div>
    <div class="modal-body">
        <div class="terminos-condicones" style="text-align: justify !important;">
            <p>El presente documento describe los terminos y condiciones generales aplicables al acceso y uso de los servicios ofrecidos por DESPACHOS ADUANEROS CHAVIMOCHIC S.A.C. ("DACHA") a traves de la aplicacion "ITURRIAPP".</p>
            <p class="font-weight-bold">I. Aceptacion de los Terminos y Condiciones</p>
            <p>Al crearse una cuenta, Usted debe aceptar estos Terminos y Condiciones para hacer uso de los servicios de DACHA.</p>
            <p class="font-weight-bold">II. Capacidad legal</p>
            <p>La Aplicacion solo esta disponible para personas que tengan capacidad legal para contratar.</p>
            <p class="font-weight-bold">III. Registro y uso de la Aplicacion</p>
            <p>El Usuario que desee registrarse debe entablar, de manera previa, una relacion comercial con DACHA.</p>
            <p class="font-weight-bold">IV. Confidencialidad</p>
            <p>Tanto el Usuario como DACHA se obligan a guardar la mas absoluta confidencialidad respecto de la informacion a la que tengan acceso.</p>
            <p class="font-weight-bold">V. Ley aplicable y jurisdiccion</p>
            <p>Estos Terminos se regiran con las leyes de la Republica del Peru, bajo jurisdiccion del Distrito Judicial de Trujillo.</p>
        </div>
    </div>
    <div class="modal-footer">
        <div class="form-check fs-15 p-3 position-absolute start-0" style="margin-left: 1.5rem !important;">
            <input class="form-check-input" type="checkbox" id="check_terminos_condiciones" (change)="fnValorCheckTerminoCondiciones()">
            <label class="form-check-label text-primary" for="check_terminos_condiciones">Acepto terminos y condiciones</label>
        </div>
        <button type="button" class="btn btn-primary" (click)="fnAceptarTerminosCondiciones()" [disabled]="isLoading || aceptoTerminosCondiciones == PARAM.NO">
            <span class="d-flex align-items-center">
                <span class="flex-grow-1 me-2">{{text_button}}</span>
                <span class="spinner-border flex-shrink-0" role="status" *ngIf="isLoading"><span class="visually-hidden"></span></span>
            </span>
        </button>
    </div>
</ng-template>

<!-- MODAL: CLASIFICACION DE CLIENTES -->
<ng-template #modalClasificacionCliente role="document" let-modal>
    <div class="modal-header">
        <h5 class="modal-title mt-0 text-success">
            <i class="ri-bar-chart-2-line me-2"></i>Clasificacion de Clientes
        </h5>
        <button type="button" class="btn-close" aria-hidden="true" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body pt-0">
        <div class="table-responsive">
            <table class="table table-hover mb-0">
                <thead class="table-light">
                <tr>
                    <th class="text-center">RUC</th>
                    <th>Cliente</th>
                    <th class="text-center">Cant. Operaciones</th>
                    <th class="text-center">Promedio KPI</th>
                </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let clasificacion of listaClasificacionClientesByOperador; let index = index;">
                        <td class="text-center"><span class="badge bg-soft-secondary text-secondary">{{clasificacion.cliente_ruc}}</span></td>
                        <td>{{clasificacion.cliente_nombrecomercial}}</td>
                        <td class="text-center"><strong class="text-success">{{clasificacion.totalOperaciones}}</strong></td>
                        <td class="text-center"><strong class="text-warning">{{clasificacion.promedioKPI}}</strong></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <app-loading-list [isLoading]="isLoading" [totalRegistros]="totalRegistrosClasificacion"></app-loading-list>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="descargarReporteClasificacionClientes()" *ngIf="listaClasificacionClientesByOperador.length > 0">
            <i class="ri-download-line me-1"></i>Descargar Excel
        </button>
        <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Cerrar</button>
    </div>
</ng-template>

<!-- MODAL: OTROS EXPORTADORES -->
<ng-template #modalOtrosExportadores role="document" let-modal>
    <div class="modal-header">
        <div>
            <h5 class="modal-title mt-0 text-primary">
                <i class="ri-team-line me-2"></i>Detalle de Exportadores — <strong>OTROS</strong>
            </h5>
            <p class="text-muted small mb-0">Clientes de menor volumen agrupados en esta categoría</p>
        </div>
        <button type="button" class="btn-close" aria-hidden="true" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body pt-0">
        <div class="table-responsive">
            <table class="table table-hover mb-0">
                <thead class="table-light">
                <tr>
                    <th>#</th>
                    <th>Cliente</th>
                    <th>RUC</th>
                    <th class="text-center">N° Contenedores</th>
                </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of listaOtrosExportadores; let i = index">
                        <td class="text-muted small">{{i + 1}}</td>
                        <td><strong>{{item.nombre}}</strong></td>
                        <td><span class="badge bg-soft-secondary text-secondary small">{{item.ruc}}</span></td>
                        <td class="text-center">
                            <span class="badge bg-soft-primary text-primary fs-13">{{item.totalOperaciones}}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <app-loading-list [isLoading]="isLoadingOtrosModal" [totalRegistros]="listaOtrosExportadores.length"></app-loading-list>
        <div class="text-center py-4" *ngIf="!isLoadingOtrosModal && listaOtrosExportadores.length === 0">
            <i-feather name="inbox" style="width:40px;height:40px;color:#adb5bd"></i-feather>
            <p class="text-muted mt-2">No se encontraron clientes en este grupo.</p>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Cerrar</button>
    </div>
</ng-template>

<ng-template #cero>0</ng-template>
